<template>
    <main-layout>
        <router-view />
    </main-layout>
</template>

<script setup lang="ts">
import MainLayout from "./layouts/MainLayout.vue";
</script>

<style lang="sass">
@use "@/styles/style"
</style>
